<div class="container-fluid">
    <!-- 
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="BMUs">
                <select njFormField id="BMUs" [(ngModel)]="Instruction.units">
                    <option *ngFor="let unit of BMUList" value='{{unit}}'>{{unit}}</option>
                </select>
                <ng-container njFormLabel>Unit</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>
-->
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventStartTime" [isRequired]="true">
                <input type="date" id="EventStartTime" njFormField [(ngModel)]="Instruction.issuedFrom"
                    (ngModelChange)="onStartDateChanged($event)" />
                <ng-container njFormLabel>Issued From</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="EventEndTime" [isDisabled]="true">
                <input type="date" id="EventEndTime" njFormField [(ngModel)]="Instruction.issuedTo" />
                <ng-container njFormLabel>Issued To</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-6">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="dateComments" [isRequired]="false">
                <input type="text" id="dateComments" njFormField [(ngModel)]="Instruction.dateComment" />
                <ng-container njFormLabel>Date Comments</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>

    <div class="row title">
        Summary
    </div>
    <div class="row">

        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="waterCommitment">
                <textarea njFormField id="waterCommitment" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.summary"></textarea>

                <ng-container njFormSubscript>{{Instruction.summary}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    <div class="row">&nbsp;</div>
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="instructionType">
                <select njFormField id="instructionType" [(ngModel)]="Instruction.instructionType">
                    <option [value]="ResIntructionType.Auction">Auction</option>
                    <option [value]="ResIntructionType.ContinuousMarket">Continuous Market</option>
                </select>
                <ng-container njFormLabel>Instruction Type</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
    </div>

    <div class="row">&nbsp;</div>
    @if (Instruction.instructionType == ResIntructionType.ContinuousMarket) {
    <!--continuous market-->
    <div class="row title">
        Continuous Market
    </div>
    <div class="col-md-12">
        <div class="text-right" [style]="'margin-bottom: 5px;'">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="AddContinuousMarketData(Instruction.continuousMarket)">
                Add
            </nj-button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="maxContractEFABlocks" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="col-md-2">Market</th>
                        <th class="col-md-1">Direction</th>
                        <th class="col-md-1">Volume</th>
                        <th class="col-md-1">Limit Price</th>
                        <th class="col-md-2">Notes</th>
                        <th class="col-md-2">Execution Strategy</th>
                        <th class="col-md-2">Template</th>
                        <th class="col-md-1">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for(RCMD of Instruction.continuousMarket; track Instruction.continuousMarket ;let i = $index) {
                    <tr>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'product'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'product'+i" njFormField [(ngModel)]="RCMD.product" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isRequired]="true" [isFloatingLabel]="true"
                                iconName="keyboard_arrow_down" [isSelect]="true" [inputId]="'direction'+i">
                                <select njFormField [id]="'direction'+i" [(ngModel)]="RCMD.direction">
                                    <option value="Buy">Buy</option>
                                    <option value="Sell">Sell</option>
                                </select>
                                <ng-container njFormLabel></ng-container>
                                <ng-container njFormSubscript>
                                </ng-container>
                            </nj-form-item>
                        </td>
                        <td><nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'volume'+i"
                                [isRequired]="true" size="small">
                                <input type="number" [id]="'volume'+i" njFormField [(ngModel)]="RCMD.volume"
                                    size="small" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td><nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'limitPrice'+i"
                                [isRequired]="true" size="small">
                                <input type="number" [id]="'limitPrice'+i" njFormField [(ngModel)]="RCMD.limitPrice"
                                    size="small" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false"
                                [hasCustomIcon]="false" [isFloatingLabel]="true" iconName="" [inputId]="'notes'+i"
                                [isRequired]="true" size="small">
                                <input type="text" [id]="'notes'+i" njFormField [(ngModel)]="RCMD.notes" />
                                <ng-container njFormSubscript></ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                                [inputId]="'executionStrategy'+i">
                                <select njFormField [id]="'executionStrategy'+i" [(ngModel)]="RCMD.executionStrategy">
                                    <option value="ManualOrder">ManualOrder</option>
                                    <option value="SmartIceberg">SmartIceberg</option>
                                    <option value="SmartVolume">SmartVolume</option>
                                </select>
                                <ng-container njFormSubscript>
                                </ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                                [inputId]="'template'+i">
                                <select njFormField [id]="'template'+i" [(ngModel)]="RCMD.template">
                                    <option value="Default">Default</option>
                                    @if (RCMD.executionStrategy == 'SmartIceberg') {
                                    <option value="UK Asset Take Profit">UK Asset Take Profit</option>
                                    <option value="SPaaS - Illiquid Best Bid Ask">SPaaS - Illiquid Best Bid Ask</option>
                                    }
                                </select>
                                <ng-container njFormSubscript>
                                </ng-container>
                            </nj-form-item>
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteInstance(Instruction.continuousMarket, i)">
                                Delete
                            </nj-button><br />
                        </td>

                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }

    @if (Instruction.instructionType == ResIntructionType.Auction) {
    <!--auction-->
    <div class="row title">
        Auction
    </div>
    <div class="row">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="spreadModel">
                <select njFormField id="spreadModel" [(ngModel)]="Instruction.spreadModel">
                    <option [value]="0">None</option>
                    <option [value]="1">Spread</option>
                </select>
                <ng-container njFormLabel>Spread Model</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-7">
            <nj-multi-select [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isRequired]="true" [isFloatingLabel]="true" iconName="keyboard_arrow_down" [isSelect]="true"
                inputId="enforBmus" [(ngModel)]="Instruction.enforBmus">
                <ng-container njSelectOptions>
                    <li nj-list-item *ngFor="let li of BMUList" [value]='li'> {{li}}</li>
                </ng-container>
                <ng-container njFormLabel>Enfor BMUs</ng-container>
                <ng-container njFormSubscript>
                </ng-container>
            </nj-multi-select>
        </div>
    </div>

    <div class="row">&nbsp;</div>
    <div class="row">
        - Close
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="closeNotes">
                <textarea njFormField id="closeNotes" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.closeNotes"></textarea>
                <ng-container njFormSubscript>{{Instruction.closeNotes}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    @if(closeFileToUpload == null){
    <div class="row" [style]="'margin-top: 5px;'">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="file">
                <input type="file" id="closeFile" njFormField accept="image/*"
                    (change)="onFileSelected('closeImage', $event)" />
                <ng-container njFormLabel>File</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="pasteFromClipboard('closeImage')">
                Paste Image
            </nj-button>
        </div>
    </div>
    }
    @else
    {
    <div class="row" [style]="'margin-top: 5px;'">
        <div class="col-md-12">
            <table id="Attachments" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>File</th>
                        <th class="w100px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <img [src]="closeFileData" [alt]="closeFileToUpload.name" [style]="'max-width: 80%;'" />
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteFile('closeImage')">
                                Delete
                            </nj-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    }

    <div class="row">&nbsp;</div>
    <div class="row">
        - CO Assumptions
    </div>
    <div class="row">
        <div class="col-md-12">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [isFloatingLabel]="false"
                inputId="coAssumptionsNotes">
                <textarea njFormField id="coAssumptionsNotes" [disabled]="false" rows="5"
                    [(ngModel)]="Instruction.coAssumptionsNotes"></textarea>
                <ng-container njFormSubscript>{{Instruction.coAssumptionsNotes}}</ng-container>
            </nj-form-item>
        </div>
    </div>
    @if(coFileToUpload == null) {
    <div class="row" [style]="'margin-top: 5px;'">
        <div class="col-md-3">
            <nj-form-item [hasError]="false" [hasHint]="false" [isDisabled]="false" [hasCustomIcon]="false"
                [isFloatingLabel]="true" iconName="" inputId="file">
                <input type="file" id="coFile" njFormField accept="image/*"
                    (change)="onFileSelected('coAssumptionsImage', $event)" />
                <ng-container njFormLabel>File</ng-container>
                <ng-container njFormSubscript></ng-container>
            </nj-form-item>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="pasteFromClipboard('coAssumptionsImage')">
                Paste Image
            </nj-button>
        </div>
    </div>
    }
    @else
    {
    <div class="row" [style]="'margin-top: 5px;'">
        <div class="col-md-12">
            <table id="Attachments" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>File</th>
                        <th class="w100px"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <img [src]="coFileData" [alt]="coFileToUpload.name" [style]="'max-width: 80%;'" />
                        </td>
                        <td>
                            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                                (buttonClick)="DeleteFile('coAssumptionsImage')">
                                Delete
                            </nj-button>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    </div>
    }
    }
    <div class="row">&nbsp;</div>
    <div class="row">
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                (buttonClick)="SaveInstruction()">
                Save
            </nj-button>
        </div>
        <div class="col-md-3">
            <nj-button size="normal" type="button" [isDisabled]="false" icon="" [hasCustomIcon]="false"
                [style]="'margin-top: 10px;'" (buttonClick)="Cancel()">
                Cancel
            </nj-button>
        </div>
    </div>
</div>